import { Action, createReducer, on } from '@ngrx/store';
import { TranslationActions } from '../actions';
import { initState, TranslationState } from '../states/translation.states';

export const translationFeatureKey = 'translation';

export const translationReducer = createReducer(
  initState,
  on(TranslationActions.setLanguageInit, (state, action) =>
    ({ ...state, selectedLanguage: action.language })),
  on(TranslationActions.setLanguageSuccess, (state, action) =>
    ({ ...state, languageJson: action.translations })),
  on(TranslationActions.setLanguageFailed, (state, action) =>
    ({ ...state, languageJson: action.error })),
);

export function reducer(state: TranslationState | undefined, action: Action) {
  return translationReducer(state, action);
}
